
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator";
import { Notify } from "quasar";
import FormValidator from "@/components/mixins/FormValidator";
import TerminosYCondicionesComponent from "@/components/Common/TerminosYCondicionesComponent.vue";

@Component({
  components: {
    TerminosYCondicionesComponent
  }
})
export default class StepDocumentos extends Mixins(FormValidator) {
  @Prop({ required: true })
  private tipoVecino!: any;
  @Prop({ required: true })
  private flotante!: any;
  @Prop({ required: true })
  private directoForm!: any;
  private downloadCI = false;
  private downloadAC = false;
  private dialogCI = false;
  private dialogACT = false;
  private dialogEST = false;
  private dialogT = false;
  private customModel = "no";
  private bTerminos = false;
  private invalidFile = false;
  private dataForm: any = "";
  private terminosFooter = false;
  private loading: boolean = false;
  private carnet: File | null = null;
  private acreditacion: File | null = null;
  private urlDocBase = "";

  private mounted() {
    this.dataForm = this.$store.state.solicitud;
  }
  private showModal() {
    if (this.tipoVecino == 2) {
      this.dialogT = true;
    } else if (this.tipoVecino == 3) {
      this.dialogEST = true;
    } else {
      this.dialogACT = true;
    }
  }
  private actionBack() {
    if (
      this.tipoVecino != 1 &&
      this.flotante == true &&
      this.directoForm == false
    ) {
      this.$store.dispatch("SET_STATE_TO_FOUR");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    } else if (this.flotante == false && this.directoForm == false) {
      this.$store.dispatch("SET_STATE_TO_FOUR");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    } else {
      this.$store.dispatch("SET_STATE_TO_THREE");

      this.$emit("stepNext", {
        step: this.$store.state.solicitud.step
      });
    }
  }
  private mostrarTerminos(footer: any) {
    this.terminosFooter = footer;
    this.bTerminos = true;
  }
  private onCloseTerminos(info: any) {
    if (info.footer == true) {
      if (info.response == true) {
        this.customModel = "si";
        this.bTerminos = false;
      } else if (info.response == false) {
        this.customModel = "no";
        this.bTerminos = false;
      } else {
        this.bTerminos = false;
      }
    } else {
      this.bTerminos = false;
    }
  }
  private checkFile(target: HTMLInputElement) {
    let flag = false;
    const extensions = ["jpg", "jpeg", "png", "pdf", "docx", "doc"];
    if (target.files && target.files[0]) {
      for (const x in extensions) {
        if (target.files[0].type.includes(extensions[x])) {
          flag = true;
        }
      }
      if (flag == false) {
        this.$swal({
          icon: "error",
          title: this.$t("notifications.titles.form").toString(),
          text: "El formato del archivo es incorrecto",
          confirmButtonText: this.$t("buttons.accept").toString()
        });
      } else if (target.files[0].size > 5 * 1024 * 1024) {
        this.invalidFile = true;
        this.$swal({
          icon: "error",
          title: this.$t("notifications.titles.form").toString(),
          text: this.$t("notifications.error.ARCHIVO_MAXIMO").toString(),
          confirmButtonText: this.$t("buttons.accept").toString()
        });
      } else if (target.files[0].size <= 0 || !flag) {
        this.$swal({
          icon: "error",
          title: this.$t("notifications.titles.form").toString(),
          text: "El archivo adjunto esta vacío. Por favor, inténtelo de nuevo.",
          confirmButtonText: this.$t("buttons.accept").toString()
        });
        this.invalidFile = true;
      } else {
        if (target.name === "acreditacion") {
          this.acreditacion = target.files[0];
        } else if (target.name === "carnet") {
          this.carnet = target.files[0];
        }
        this.invalidFile = false;
      }
    }
  }
  private submit() {
    if (this.dataForm.mensaje == "nuevo") {
      if (this.carnet == null) {
        this.$swal({
          icon: "error",
          title: this.$t("notifications.titles.form").toString(),
          text: this.$t("notifications.error.NO_CARNET").toString(),
          confirmButtonText: this.$t("buttons.accept").toString()
        });
        return;
      }

      if (this.acreditacion == null) {
        this.$swal({
          icon: "error",
          title: this.$t("notifications.titles.form").toString(),
          text: this.$t("notifications.error.NO_ACREDITACION").toString(),
          confirmButtonText: this.$t("buttons.accept").toString()
        });
        return;
      }
    }
    if (this.customModel == "no" || !this.customModel) {
      this.$swal({
        icon: "error",
        title: this.$t("notifications.titles.form").toString(),
        text: this.$t("notifications.error.ERROR_TERMINOS").toString(),
        confirmButtonText: this.$t("buttons.accept").toString()
      });
      return;
    }
    this.loading = true;
    this.$q.loading.show({
      delay: 100 // ms
    });

    const data = new FormData();
    if (this.carnet) {
      const ciFile = this.carnet as Blob;
      data.append("carnet", ciFile);
    } else {
      const ciFile = new File(["file"], "Carnet") as Blob;
      data.append("carnet", ciFile);
    }
    if (this.acreditacion) {
      const acFile = this.acreditacion as Blob;
      data.append("acreditacion", acFile);
    } else {
      const acFile = new File(["file"], "Acreditación") as Blob;
      data.append("acreditacion", acFile);
    }
    for (const prop in this.dataForm) {
      if (this.dataForm.hasOwnProperty(prop)) {
        // @ts-ignore
        if (this.dataForm[prop] || this.dataForm[prop] === 0) {
          // @ts-ignore
          data.append(prop, this.dataForm[prop]);
        }
      }
    }
    if (!this.dataForm.apellidoMaterno) {
      data.append("apellidoMaterno", "");
    }

    if (this.dataForm.tipoVecino == 1) {
      this.$axios
        .post("vecino", data, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(result => {
          this.loading = false;
          this.$q.loading.hide();
          this.$swal({
            icon: "success",
            title: this.$t("notifications.titles.form").toString(),
            text: this.$t("notifications.success.application").toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });

          this.$router.push({ name: "ApplicationsList" });
        })
        .catch(error => {
          this.$q.loading.hide();
          const message = error.response.data.message;
          if (message === "FILEA_ERROR") {
            this.$swal({
              icon: "error",
              title: this.$t("notifications.titles.form").toString(),
              text: this.$t("notifications.error.FILEA_ERROR").toString(),
              confirmButtonText: this.$t("buttons.accept").toString()
            });
          } else if (message === "FILEC_ERROR") {
            this.$swal({
              icon: "error",
              title: this.$t("notifications.titles.form").toString(),
              text: this.$t("notifications.error.FILEC_ERROR").toString(),
              confirmButtonText: this.$t("buttons.accept").toString()
            });
          } else if (message == "TOKEN_ERROR") {
            this.$swal({
              icon: "warning",
              title: this.$t("notifications.titles.atention").toString(),
              text: this.$t("notifications.error.TOKEN_ERROR").toString(),
              confirmButtonText: this.$t("buttons.accept").toString()
            });
            this.$router.push({ name: "login" }).catch(err => {});
          } else {
            this.$swal({
              icon: "error",
              title: this.$t("notifications.titles.form").toString(),
              text: this.$t("notifications.error.ERROR_FORM").toString(),
              confirmButtonText: this.$t("buttons.accept").toString()
            });
          }
          this.loading = false;
        });
    } else {
      this.$axios
        .post("vecino/flotante", data, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(result => {
          this.$q.loading.hide();
          this.loading = false;
          this.$swal({
            icon: "success",
            title: this.$t("notifications.titles.form").toString(),
            text: this.$t("notifications.success.application").toString(),
            confirmButtonText: this.$t("buttons.accept").toString()
          });

          this.$router.push({ name: "ApplicationsList" });
        })
        .catch(error => {
          const message = error.response.data.message;
          if (message === "FILEA_ERROR") {
            this.$swal({
              icon: "error",
              title: this.$t("notifications.titles.form").toString(),
              text: this.$t("notifications.error.FILEA_ERROR").toString(),
              confirmButtonText: this.$t("buttons.accept").toString()
            });
          }
          if (message === "FILEC_ERROR") {
            this.$swal({
              icon: "error",
              title: this.$t("notifications.titles.form").toString(),
              text: this.$t("notifications.error.FILEC_ERROR").toString(),
              confirmButtonText: this.$t("buttons.accept").toString()
            });
          }

          if (message == "TOKEN_ERROR") {
            this.$swal({
              icon: "warning",
              title: this.$t("notifications.titles.atention").toString(),
              text: this.$t("notifications.error.TOKEN_ERROR").toString(),
              confirmButtonText: this.$t("buttons.accept").toString()
            });
            this.$router.push({ name: "login" }).catch(err => {});
          }

          if (message === "COMUNA_ID_INVALID") {
            this.$swal({
              icon: "error",
              title: this.$t("notifications.titles.form").toString(),
              text: this.$t("notifications.error.NO_COMUNA").toString(),
              confirmButtonText: this.$t("buttons.accept").toString()
            });
          }
          this.loading = false;
          this.$q.loading.hide();
        });
    }
  }
}
